module.exports = __webpack_public_path__ + "025ef6e60fc6a7af8ce682048b2452af.svg";